import { createFileRoute } from "@tanstack/react-router";
import { NewConversation } from "@/components/new-conversation";

/** Home = start a new ask. The ask list lives in the inset sidebar; this main
 * panel is the fresh-thread composer (ChatGPT/Claude style). */
function AsksHome() {
  return <NewConversation />;
}

export const Route = createFileRoute("/")({ component: AsksHome });
